import NavBar from './NavBar';
import AdminLogin from './AdminLogin';

const Admin = () => {
  return (
    <div className="m-auto max-w-5xl">
      <NavBar />
      <AdminLogin />
    </div>
  );
};

export default Admin;
